
const youtube = {

    isvalid: function (url) {

        if (url.includes("https://www.youtube.com")
            || url.includes("https://youtu.be/")) {
            return true;
        }

        return false;
    },
    
    transform: function (url) {

        let newurl = url;
        let uri = url;
    
        uri = uri.replace("https://www.youtube.com/watch?v=", "");
        uri = uri.replace("https://youtu.be/", "");
        newurl = "https://www.youtube.com/embed/" + uri;

        return newurl;

    }

};

const embebed = (url) => {

    if ( youtube.isvalid(url) )
        return youtube.transform(url);

    return url;

};

const URL = {
    embebed
};

export default URL;
